module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files && _vm.files.length) ? _c('div', {
    staticClass: "attachments-container"
  }, _vm._l((_vm.files), function(item, index) {
    return _c('div', {
      key: index
    }, [(_vm.isImage(item)) ? _c('img', {
      staticClass: "image-attachment",
      attrs: {
        "src": _vm.getSrc(item)
      }
    }) : (_vm.isVideo(item)) ? _c('video', {
      staticClass: "image-attachment",
      attrs: {
        "src": _vm.getSrc(item),
        "autoplay": "",
        "controls": "controls",
        "muted": "muted"
      },
      domProps: {
        "muted": true
      }
    }) : (_vm.isAudio(item)) ? _c('audio', {
      attrs: {
        "controls": "",
        "src": _vm.getSrc(item)
      }
    }) : _c('a', {
      staticClass: "link-attachment",
      attrs: {
        "target": "_blank",
        "href": _vm.getSrc(item)
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getNameFile(item))
      }
    })])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27211e30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/attachments.vue
// module id = 404
// module chunks = 2